import { AnyGoalDoc, NewMultiStepGoal } from "@ailenax-overlay/shared";

export const getEffectiveMultiStepProgress = (goal: NewMultiStepGoal): number => {
    if (!goal.wrapAround) {
        return goal.progress;
    }
    const sumOfSteps = goal.steps.reduce((sum, step) => sum + step.goal, 0);
    if (sumOfSteps === 0) {
        return goal.progress;
    }
    return goal.progress % sumOfSteps;
};

export const getMultiStepStep = (goal: NewMultiStepGoal) => {
    const progress = getEffectiveMultiStepProgress(goal);
    return goal.steps.find(s => s.goal > progress) ?? goal.steps[goal.steps.length - 1];
};

export const getMultiStepProgress = (goal: NewMultiStepGoal) => {
    const progress = getEffectiveMultiStepProgress(goal);
    const currentStep = getMultiStepStep(goal);
    const stepIndex = goal.steps.indexOf(currentStep);
    const prevThreshold = stepIndex > 0 ? goal.steps[stepIndex - 1].goal : 0;
    const currentThreshold = currentStep.goal;
    const stepSize = currentThreshold - prevThreshold;
    const realProgress = Math.max(0, progress - prevThreshold);
    const fraction = stepSize > 0 ? Math.min(1, realProgress / stepSize) : 1;

    return {
        currentStep,
        prevThreshold,
        currentThreshold,
        realProgress,
        stepSize,
        fraction,
    };
};

export const getCurrentTitle = (goal: AnyGoalDoc) => {
    if (goal.goalType === "simple") {
        const num = ~~(goal.progress / goal.goal);
        if (num === 0 || !goal.autoReset) {
            return goal.title.replace("[counter]", "").replace(/\s+/, " ");
        }
        return goal.title.replace("[counter]", `(${num.toFixed(0)}x)`);
    }

    return getMultiStepStep(goal).title;
};
